<template>
	<div class="page-wrapper">
		<div class="page-breadcrumb d-flex justify-content-between">
			<h2 class="page-title">Setting</h2> 
		</div>
	</div>
</template>
<script>
export default {
  name: 'projectsSetting'
};
</script>
<style scoped lang="scss">

</style>
